import ApiClient from './ApiClient';

class CustomRolesAPI extends ApiClient {
  constructor() {
    super('custom_roles', { accountScoped: true });
  }
}

export default new CustomRolesAPI();
